import { useNavigate, useLocation } from "react-router-dom";
import { Reveal } from "./motion-primitives";
import { scrollToId } from "./SmoothScroll";

const logoUrl = `${process.env.PUBLIC_URL}/holideviser-logo.svg`;

// type: "section" scrolls to a homepage section (navigating home first if needed); "route" navigates to a page.
const NAV = [
  { label: "Discoverography", type: "route", to: "/discoverography" },
  { label: "Destinations", type: "route", to: "/destinations" },
  { label: "Plan My Trip", type: "route", to: "/plan-my-trip" },
  { label: "Our Approach", type: "section", id: "approach" },
  { label: "Contact", type: "route", to: "/contact" },
];

const LEGAL = [
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goSection = (id) => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 450);
    } else {
      scrollToId(id);
    }
  };
  const goTop = () => {
    if (pathname !== "/") navigate("/");
    else scrollToId("top");
  };

  return (
    <footer data-testid="main-footer" className="border-t border-charcoal bg-ink">
      <div className="mx-auto max-w-[1400px] px-6 py-20 sm:px-10 lg:px-16 lg:py-24">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Reveal>
              <button
                onClick={goTop}
                data-testid="footer-logo"
                aria-label="Holideviser"
                className="inline-flex transition-opacity duration-300 hover:opacity-80"
              >
                <img src={logoUrl} alt="Holideviser" className="h-9 w-auto sm:h-10" />
              </button>
            </Reveal>
            <Reveal delay={0.06}>
              <p className="mt-8 max-w-sm font-serif text-xl font-light italic leading-snug text-sand">
                Travel like the local-with-good-taste you wish you knew.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <Reveal>
              <span className="font-sans text-xs uppercase tracking-[0.3em] text-sand">
                Navigate
              </span>
            </Reveal>
            <ul className="mt-6 flex flex-col gap-4">
              {NAV.map((l, i) => (
                <li key={l.label}>
                  <Reveal delay={i * 0.04}>
                    <button
                      onClick={() => (l.type === "route" ? navigate(l.to) : goSection(l.id))}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="link-underline font-sans text-base text-cream/85 hover:text-cream"
                    >
                      {l.label}
                    </button>
                  </Reveal>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2 lg:col-start-11">
            <Reveal>
              <span className="font-sans text-xs uppercase tracking-[0.3em] text-sand">Legal</span>
            </Reveal>
            <ul className="mt-6 flex flex-col gap-4">
              {LEGAL.map((l, i) => (
                <li key={l.label}>
                  <Reveal delay={i * 0.04}>
                    <button
                      onClick={() => navigate(l.to)}
                      data-testid={`footer-legal-${l.label.toLowerCase()}`}
                      className="link-underline font-sans text-base text-cream/85 hover:text-cream"
                    >
                      {l.label}
                    </button>
                  </Reveal>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-charcoal pt-8 sm:flex-row sm:items-center">
          <span className="font-sans text-xs tracking-[0.14em] text-sand">
            © {new Date().getFullYear()} Holideviser. Curated, not crowdsourced.
          </span>
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-sand">
            Made for the curious
          </span>
        </div>
      </div>
    </footer>
  );
};
